export default "__VITE_ASSET__CQUOrv4V__"